import { ReactNode, memo } from "react";
import clsx from "clsx";
import { Box } from "@mui/material";
import { InfoContainer } from "$components";
import { TitleInfoContainer } from "$components/InfoContainer/TitleInfoContainer";
import { ButtonEditInfoContainer } from "$components/InfoContainer/ButtonEditInfoContainer";
import { SimpleTable } from "$components/Table/SimpleTable/SimpleTable";
import { useStyles } from "./InfoContainer.styles";
import { Loader } from "$components/Layout/Loader";

interface EditableInfoContainerProps {
  title: string;
  icon: ReactNode;
  style?: object;
  data: { label: string; value: string | ReactNode; className?: any }[];
  dataRight?: { label: string; value: string | ReactNode; className?: any }[];
  className?: any;
  editButton?: { onClick: () => void; isDisabled: boolean };
  colData?: number;
  isLoading?: boolean;
}

export const EditableInfoContainer = memo(function EditableInfoContainer({
  title,
  icon,
  style,
  data,
  dataRight,
  className = [],
  editButton,
  colData,
  isLoading,
}: EditableInfoContainerProps) {
  const classes = useStyles();

  return (
    <InfoContainer
      className={clsx([classes.topBlock, ...className])}
      leftHeader={<TitleInfoContainer title={title} icon={icon} />}
      rightHeader={
        editButton && (
          <ButtonEditInfoContainer
            onClick={editButton.onClick}
            disabled={editButton.isDisabled}
            className={classes.editButton}
          />
        )
      }
      style={style}
    >
      <Box className="about">
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <Box className="left">
              <SimpleTable data={data} col={colData} />
            </Box>
            {dataRight && (
              <Box className="right">
                <SimpleTable data={dataRight} />
              </Box>
            )}
          </>
        )}
      </Box>
    </InfoContainer>
  );
});
